import _ from 'lodash'
import $ from 'jquery'
import Backbone from 'backbone'
import template from './dataset-series-creator.hbs'
import i18n from 'scoreboard/components/i18n'
import ObjectSelector from 'scoreboard/components/object-selector'
import dropdown from 'scoreboard/components/dropdown'
import config from 'scoreboard/components/config'
import selects from 'scoreboard/components/selects'
import formHelper from 'scoreboard/components/form-helper'
import FormView from 'scoreboard/components/form-view'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import cleanDatasetSeries from './clean-dataset-series'
import highlight from 'scoreboard/components/highlight'
import DatasetSeriesForm from './dataset-series-form'
import calendars from 'scoreboard/components/calendars'
import globals from 'scoreboard/components/globals'
import projects from 'scoreboard/projects/projects'
import showNativeCalendar from 'scoreboard/scorecards/show-native-calendar'
import Dataset from 'scoreboard/datasets/model/dataset'
const { SNAPSHOT } = Dataset
import includeDescendantsInputLabel from 'scoreboard/scorecards/edit/include-descendants-input-label'

var DatasetSeriesCreator = DatasetSeriesForm.extend({

	className: 'dataset-series-creator',

	tagName: 'form',

	events: {
		'change [name=existing]': 'changeExisting',
		'change [name=existing], [name=calendarFieldIdentifier]': 'toggleNativeCalendar'
	},

	/** @type {Dataset} */
	model: null,

	/**
	 * Dialog for creating dataset metrics.  They are edited using
	 * dataset-series-editor.js.  The options available in DatasetSeries.kt can be
	 * passed in here to initialize the values for the dataset metric
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Dataset} options.model the Dataset
	 *
	 * @param {Number} [options.calendarFieldIdentifier] the calendar field
	 * identifier
	 */
	initialize: function(options) {
		this.options = options || {}
		this.selectedMetricNode = undefined

		var MyFormView = FormView.extend({
			test: this.test.bind(this)
		})
		this.formView = new MyFormView({
			el: this.el,
			guard: false,
			submit: this.submit.bind(this)
		})

		this.objectSelector = new ObjectSelector({
			section: 'scorecards',
			projectId: projects.selectedOrFirstId(),
			orgId: globals.orgId,
			objectParams: {
				scoringType: true,
				calendarId: true,
				series: true
			},
			showProjectSelector: true
		})
		this.objectSelector.on('selectOrg', this.onSelectOrg.bind(this))
		this.objectSelector.on('select', this.select.bind(this))

		this.objectSelector.on('org:tree:rendered', () => {
			// Once the tree is loaded, we have the info needed to do the initial
			// render of the includeDescendants checkbox
			this.renderIncludeDescendants({
				organization: this.objectSelector.selectedOrg()
			})
		})
	},

	render: function() {
		let highlighted = highlight(i18n.get('datasets.metric.snapshot'))
		let banner1 = i18n.get('datasets.metric.banner')
		let banner2 = i18n.get('datasets.metric.banner2', highlighted)

		// render all the controls
		this.$el.empty().append(template({ banner1, banner2 }))

		this.renderCalendarField()
		this.renderNativeCalendarDropdown()
		this.renderIncludeDescendants()

		selects(this.$('[name=series]'))

		this.$('.object-selector').replaceWith(this.objectSelector.el)
		this.objectSelector.render()

		this.addMarkedFields()

		this.changeExisting()

		this.formView.start()

		return this
	},

	/**
	 * Specifies the native calendar ID for snapshot metrics.
	 */
	renderNativeCalendarDropdown() {
		var calendarId = calendars.calendars[0].id
		dropdown.idLabels(this.$('[name=calendarId]').empty(), calendars.calendars, calendarId)
		this.toggleNativeCalendar()
	},

	/**
	 * Toggles the display of a native calendar dropdown so that it's visible
	 * when appropriate. #27550 It will only display for new snapshot metrics or
	 * existing snapshot IF all of the existing
	 * metric’s series don't already have a calendar (i.e. not dataset snapshot,
	 * manual, or calculated).
	 */
	toggleNativeCalendar() {
		let selectedSnapshotField = this.$('[name=calendarFieldIdentifier]')
			.val() == SNAPSHOT
		let hideNativeCalendar = true

		// Show native calendar for new snapshot metrics
		if (!this.isExisting() && selectedSnapshotField) {
			hideNativeCalendar = false
		} else if (selectedSnapshotField && this.selectedMetricNode) {
			// #27550 If a metric has a series that shows the native calendar
			// dropdown (e.g. snapshot dataset), we actually hide that dropdown
			// for this screen.
			hideNativeCalendar = showNativeCalendar(this.selectedMetricNode
				.series)
		}

		// #36338 show native calendar when creating a snapshot series for
		// existing metrics that currently don't have a calendarId
		if (this.isExisting() && selectedSnapshotField && this.selectedMetricNode
			&& _.isNil(this.selectedMetricNode.calendarId)) {
			hideNativeCalendar = false
		}

		return this.$('.native-calendar').toggleClass('is-not-displayed',
			hideNativeCalendar)
	},

	renderIncludeDescendants({ organization } = {}) {
		let fieldLabel
		if (organization) {
			fieldLabel = includeDescendantsInputLabel({
				dataset: this.model,
				metricOrganization: organization
			})
		}

		this.$('.include-descendants')
			.toggleClass('is-not-displayed', !fieldLabel)
			.find('.label-text').html(fieldLabel)
	},

	addMarkedFields: function() {
		this.labelField = new MarkedField({
			el: this.$('[name=label]'),
			validator: requiredValidator
		}).render()
		this.calendarFieldIdentifierField = new MarkedField({
			el: this.$('[name=calendarFieldIdentifier]'),
			validator: requiredValidator
		}).render()
		this.calendarIdField = new MarkedField({
			el: this.$('[name=calendarId]'),
			validator: requiredValidator
		}).render()
	},

	/**
	 * Toggles visibility of controls based on whether or not we are working
	 * with an existing metric.
	 */
	changeExisting: function() {
		var existing = this.isExisting()
		var objectSelectorKey = existing ? 'datasets.metric.existing' :
			'datasets.metric.parent'
		this.$('.object-selector-label').text(i18n.get(objectSelectorKey))

		this.$('label.label').toggleClass('is-not-displayed', existing)
		this.$('label.series').toggleClass('is-not-displayed', !existing)

		_.invokeMap([this.labelField, this.seriesField], 'clearError')
		this.$el.removeClass('has-error')
	},

	/**
	 * Returns true if we're working with an existing metric
	 */
	isExisting: function() {
		return this.$('[name=existing]:checked').val() === 'true'
	},

	/**
	 * Callback handling when the user clicks on a scorecard node
	 */
	select: function(node) {
		this.selectedMetricNode = node
		// When we select from an existing metric, we check if we display the
		// native calendar
		this.toggleNativeCalendar()
		this.formView.change()
		_.invoke(this.seriesField, 'clearError')
		if (node.scoringTypeId) {
			var previous = this.$('[name=series]').val()
			var thresholdNames = config.scoringType(node.scoringTypeId).thresholdNames
			var seriesNames = [ 'scorecards.node.metric.actualValue' ]
			if (thresholdNames) {
				seriesNames = seriesNames.concat(thresholdNames)
			}
			var selected = undefined
			if (_.indexOf(seriesNames, previous) != -1) {
				selected = previous
			}
			dropdown.keys(this.$('[name=series]').empty(), seriesNames, selected)
		}
	},

	onSelectOrg (selected) {
		this.renderIncludeDescendants({ organization: selected })
		this.formView.change()
	},

	test: function() {
		var problem = FormView.prototype.test.apply(this, arguments)
		if (problem) {
			return problem
		}

		var scorecardItem = _.result(this.objectSelector, 'selected')
		if (this.isExisting()) {
			if (_.get(scorecardItem, 'type') !== 'metric') {
				return i18n.get('datasets.metric.existing.mustBeMetric')
			}
		} else {
			if (!scorecardItem) {
				// if the org is empty
				if (_.isNil(this.objectSelector.objectGardener.tree.get())) {
					return i18n.get('alerts.mustSelectAScorecardObject')
				}
			} else if (scorecardItem.type === 'linked') {
				return i18n.get('datasets.metric.parent.invalid')
			}
		}
	},

	submit: function(e) {
		var datasetSeries = _.omit(this.options, 'model', 'id', 'filters')
		datasetSeries.filters = this.getDatasetMetricFilters()
		datasetSeries.id = this.model.get('rootDatasetId')
		datasetSeries = _.defaults(formHelper.readFromDom(this.el), datasetSeries)
		if (!datasetSeries.label) {
			datasetSeries.label = this.objectSelector.selected().label
		}
		// If the user selected snapshot, but wasn't presented with the native
		// calendar dropdown (due to #27550), then we use the selected metric's
		// calendarId. This prevents a blowup.
		if (Dataset.SNAPSHOT == datasetSeries.calendarFieldIdentifier &&
			!datasetSeries.calendarId) {
			datasetSeries.calendarId = this.selectedMetricNode.calendarId
		}
		datasetSeries.organizationId = this.objectSelector.selectedOrg().id
		datasetSeries.scorecardItemId = _.get(this.objectSelector.selected(), 'id')
		cleanDatasetSeries(datasetSeries)
		let calendarFieldIds = this.model.fieldIdentifierToIds(datasetSeries.calendarFieldIdentifier)
		datasetSeries.calendarFieldId = calendarFieldIds.fieldId
		datasetSeries.calendarVisibleLinkedFieldId = calendarFieldIds.visibleLinkedFieldId
		delete datasetSeries.calendarFieldIdentifier
		$.post({
			url: 'api/datasets/' + this.model.get('rootDatasetId') + '/series',
			data: JSON.stringify(datasetSeries),
			success: (response) => {
				this.trigger('done', datasetSeries, response)
			},
			error: this.formView.error.bind(this.formView)
		})
	},

	getDatasetMetricFilters: function() {
		let linkGroups = _(this.options.filters).map('linkGroup')
		let maxLinkGroup = linkGroups.max()
		let linkGroupValues = linkGroups.value()

		let securityLinkGroups = {}
		return _(this.options.filters)
			// remove permission filters if appropriate
			.filter(filter => (_.isNil(filter.permissionId) ||
				// #31722 if the user doesn't see any filters on the explore and
				// records tabs, don't include any filters on the KPI so the
				// numbers match what the user who created the KPI is seeing
				!this.model.get('hasUnfilteredPermission')) &&
				// #33701 if a filter just restates the value
				// of the dataset series (i.e. when one drills down on a single
				// item), don't include it
				!this.filterIsValue(filter, linkGroupValues)
			)
			// give the security filters or groups that don't overlap with
			// the active filters (#31723)
			.map(filter => {
				if (filter.permissionId) {
					let revisedLinkGroup = securityLinkGroups[filter.linkGroup]
					if (_.isNil(revisedLinkGroup)) {
						securityLinkGroups[filter.linkGroup] = revisedLinkGroup =
							++maxLinkGroup
					}
					filter = _.extend({}, filter, {
						linkGroup: revisedLinkGroup
					})
					// #31724 these are no longer security filters
					delete filter.permissionId
				}
				return filter
			})
			.value()
	},

	filterIsValue: function(filter, linkGroups) {
		let value =_.get(this.options, 'value')

		// field has an is-any operator and is not related to a rollup item
		if (_.isNil(value) || filter.operator !== 'is-any' ||
			!_.isEmpty(filter.rollupIsAnyFilters)) {
			return false
		}

		// filter does not have an linkGroup partner/partners
		let hasPartnerFilter =
			linkGroups.indexOf(filter.linkGroup) != linkGroups.lastIndexOf(filter.linkGroup)
		// value's field matches filter's field
		let matchingFields = value.fieldId == filter.fieldId

		// filter is singular/non-related and
		// filter's value matches value's value
		let matchingValues = !hasPartnerFilter && filter.values.length == 1 &&
			filter.values[0] == value.value

		return matchingFields && matchingValues
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.objectSelector, this.labelField,
			this.calendarFieldIdentifierField, this.calendarIdField], 'remove')
	}

})

export default DatasetSeriesCreator

DatasetSeriesCreator.__filename__ = 'datasets/dataset-series-creator.js'
